const OPAQUE_SCRIPT_ERROR = /^(?:[A-Za-z_$][\w$]*:\s*)?Script error\b/i;

export function isOpaqueCrossOriginException(envelope) {
  if (envelope?.baseType !== 'ExceptionData') {
    return false;
  }

  const message = envelope?.baseData?.exceptions?.[0]?.message;

  return !!message && OPAQUE_SCRIPT_ERROR.test(message);
}

export function crossOriginExceptionFilter(envelope) {
  return !isOpaqueCrossOriginException(envelope);
}
